import { HTTP, authHeader } from './http-service';

class UserRoleGroupsService {
  list() {
    return HTTP.get(`/userRoleGroup`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  get(id) {
    return HTTP.get(`/userRoleGroup/${id}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  update(payload) {
    return HTTP.put(`/userRoleGroup`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/userRoleGroup`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  delete(id) {
    return HTTP.delete(`/userRoleGroup/${id}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new UserRoleGroupsService();
